import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Reveal } from "../components/Reveal";

export default function LegalPage({ page }) {
  useEffect(() => {
    document.title = page.metaTitle;
    return () => {
      document.title = "DS LAB STUDIO | Siti Web Professionali per Attività e Professionisti";
    };
  }, [page.metaTitle]);

  return (
    <main className="bg-white">
      <div className="border-b border-line bg-mist">
        <div className="mx-auto max-w-4xl px-5 py-14 sm:px-8 sm:py-20">
          <Link
            to="/"
            data-testid="legal-back-home"
            className="inline-flex items-center gap-2 text-sm font-semibold text-navy transition-colors duration-200 hover:text-celeste-dark"
          >
            <ArrowLeft className="h-4 w-4" aria-hidden="true" />
            Torna alla home
          </Link>
          <h1 className="mt-6 font-display text-3xl font-bold tracking-tight text-navy-dark sm:text-5xl">
            {page.title}
          </h1>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-steel sm:text-base">{page.intro}</p>
        </div>
      </div>

      <div className="mx-auto max-w-4xl px-5 py-12 sm:px-8 sm:py-16">
        {page.sections.map((section, i) => (
          <Reveal key={section.heading} as="section" className={i > 0 ? "mt-10" : ""}>
            <h2 className="font-display text-xl font-semibold text-navy-dark sm:text-2xl">
              {section.heading}
            </h2>
            {section.body.map((paragraph) => (
              <p key={paragraph.slice(0, 40)} className="mt-3 text-sm leading-relaxed text-steel sm:text-base">
                {paragraph}
              </p>
            ))}
          </Reveal>
        ))}
      </div>
    </main>
  );
}
